import * as actions from '~/actions/autosuggestFilter';

const defaultState = {};

const autosuggestFilterState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.UPDATE_AUTOSUGGEST_VALUE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          value: action.value,
        },
      };
    case actions.UPDATE_AUTOSUGGEST_SUGGESTIONS:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          suggestions: action.suggestions,
        },
      };
    default:
      return state;
  }
};

export default autosuggestFilterState;
